import {
	get,
	post,
	postForm,
	postfile
} from '../axios-req.js'
post
get
postForm

export const autoFormApi = {
    //暂存问题
	selectSaveQuestions: (data) => {
		return post('/questionnaire/updateQuestionnaireBank', data)
	},
	selectSubmit: (data) => {
		return postForm('questionnaire/submitQuestion', data)
	},
	// 上传文件
	uploadFileApi: (data) => {
		return postfile('/questionnaire/uploadFiles', data)
	},
	// 查看文件
	downloadFileApi: (data) => {
		return get('/questionnaire/downloadFile', data)
	},
	// 是否公开
	visibilityApi: (data) => {
		return post('/questionnaire/visibility', data)
	},

}